import * as THREE from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js'
import { RGBELoader } from 'three/examples/jsm/loaders/RGBELoader.js'
import GUI from 'lil-gui'
import { clone } from 'three/examples/jsm/utils/SkeletonUtils.js'

/**
 * Base
 */
// Debug
const gui = new GUI()
gui.hide()

// Canvas
const canvas = document.querySelector('canvas.webgl')

// Scene
const scene = new THREE.Scene()

/**
 * Models
 */

const gltfLoader = new GLTFLoader()
const elementosGroup = new THREE.Group()
//let modelo2Morex = null
//let modelo3Morex = null
const totalClobnes = 150
scene.add(elementosGroup)
//gltfLoader.setDRACOLoader(dracoLoader)

let mixer = null

gltfLoader.load(
    '/models/hamburger2.glb',
    (gltf) =>
    {
        for(let i = 0; i < totalClobnes; i++)
        {
            const clone = gltf.scene.clone()

            // Posición aleatoria en X
            clone.position.x = (Math.random() - 0.5) * 100
            clone.position.y = (Math.random() - 0.5) * 100
            clone.position.z = (Math.random() - 0.5) * 150

            // 15 normales, 15 rotadas 180° en X
            if(i < totalClobnes * 0.5)
            {
                clone.rotation.z = 0
            }
            else
            {
                clone.rotation.z= Math.PI  // 180°
            }

            // Aplicar material a cada clon
            clone.traverse((child) =>
            {
                if(child.isMesh)
                {
                    child.material = material
                }
            })

            elementosGroup.add(clone)
        }
    }
)
gltfLoader.load(
    '/models/hamburger2.glb',
    (gltf2MorexC)=>
    {
        const modelo2Morex = gltf2MorexC.scene.children[0]

        modelo2Morex.position.set(2, 0, 0)
        modelo2Morex.rotation.set(0, (Math.PI * 0.025), 0)
        //modelo2Morex = gltf2MorexC.scene
        scene.add(modelo2Morex)


    }
)

    gltfLoader.load(
    '/models/hamburger2.glb',
    (gltf3MorexC)=>
    {
        const modelo3Morex = gltf3MorexC.scene.children[0]

        modelo3Morex.position.set(8, 0, -1)
        modelo3Morex.rotation.set(0, (Math.PI * 1.025), 0)
        //modelo3Morex = gltf3MorexC.scene
        scene.add(modelo3Morex)
    }
)







// Material
const material = new THREE.MeshPhysicalMaterial()
material.roughness = 0.3
material.metalness = 0.6
material.color.set('#e1fefe')
material.transparent = true
material.opacity = 0.5
material.side = THREE.DoubleSide
material.shininess = 100
material.specular = new THREE.Color('#25d4a9')
material.sheen = .6
material.sheenRoughness = 0.3
material.sheenColor.set('#36dddd')
material.iridescence = 0.8
material.iridescenceIOR = 1.8
material.iridescenceThicknessRange = [ 100, 800 ]
material.transmission = 0.8
material.ior = 2
material.thickness = 0.3


const textureLoader = new THREE.TextureLoader()
const environmentMap = textureLoader.load('/textures/environmentMap/morex_2k.webp')
environmentMap.mapping = THREE.EquirectangularReflectionMapping
scene.background = environmentMap
scene.environment = environmentMap

/**
 * Lights
 */
const ambientLight = new THREE.AmbientLight(0xffffff, .75)
scene.add(ambientLight)

const directionalLight = new THREE.DirectionalLight('#a8e4e0', 3)
directionalLight.position.set(2, 6, 2)
directionalLight.rotation.set(- Math.PI / 4, Math.PI / 4, 0)
scene.add(directionalLight)
const directionalLightHelper = new THREE.DirectionalLightHelper(directionalLight, 0.2)
const directionalLight2 = new THREE.DirectionalLight('#e4e0a8', 3)
directionalLight2.position.set(-2, -3, -2)
directionalLight2.rotation.set(- Math.PI / 4, Math.PI / 4, 0)
scene.add(directionalLight2)
const directionalLightHelper2 = new THREE.DirectionalLightHelper(directionalLight2, 0.2)
//scene.add(directionalLightHelper2)
const pointLight = new THREE.PointLight('#e4e0a8', 10)
pointLight.position.set(0, 0, 0)
scene.add(pointLight)
const pointLightHelper = new THREE.PointLightHelper(pointLight, 0.2)
//scene.add(pointLightHelper)

/**
 * Sizes
 */
const sizes = {
    width: window.innerWidth,
    height: window.innerHeight
}

window.addEventListener('resize', () =>
{
    // Update sizes
    sizes.width = window.innerWidth
    sizes.height = window.innerHeight

    // Update camera
    camera.aspect = sizes.width / sizes.height
    camera.updateProjectionMatrix()

    // Update renderer
    renderer.setSize(sizes.width, sizes.height)
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
})

/**
 * Camera
 */
// Base camera
const camera = new THREE.PerspectiveCamera(75, sizes.width / sizes.height, 0.1, 100)
camera.position.set(- 5, 1, 7)
scene.add(camera)
gui .add(camera.position, 'x').min(- 20).max(20).step(0.001)
gui .add(camera.position, 'y').min(- 20).max(20).step(0.001)
gui .add(camera.position, 'z').min(- 20).max(20).step(0.001)

// Controls
const controls = new OrbitControls(camera, canvas)
controls.target.set(0, 1, 0)
controls.enableDamping = true
controls.enabled = true

/**
 * Renderer
 */
const renderer = new THREE.WebGLRenderer({
    canvas: canvas,
    alpha: true
})
renderer.setClearAlpha(0)
renderer.shadowMap.enabled = true
renderer.shadowMap.type = THREE.PCFSoftShadowMap
renderer.setSize(sizes.width, sizes.height)
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))

/**
 * Animate
 */
const clock = new THREE.Clock()
let previousTime = 0
let cameraPosition = { x: camera.position.x, y: camera.position.y, z: camera.position.z }
let scrollY = window.scrollY


//let scrollX = window.scrollX
window.addEventListener('scroll', () =>
{
    scrollY = window.scrollY
})

const mouse = { x: 0, y: 0 }

window.addEventListener('mousemove', (e) =>
{
    // Normaliza entre -1 y 1
    mouse.x = (e.clientX / sizes.width - 0.5) * 2
    mouse.y = (e.clientY / sizes.height - 0.5) * 2
})


const tick = () =>
{
    const elapsedTime = clock.getElapsedTime()
    const deltaTime = elapsedTime - previousTime
    previousTime = elapsedTime

        // Rotar la escena en X
    elementosGroup.rotation.y = elapsedTime * 0.05  // ← ajusta la velocidad

      // Mover cámara según mouse con lerp (suavizado)
    camera.position.x += (mouse.x * 8 - camera.position.x) * 0.05
    camera.position.y += (- mouse.y * 4 - camera.position.y) * 0.05
    camera.lookAt(0, 0, 0)


    if(mixer)
    {
        mixer.update(deltaTime)
    }


    /*if(modelo2Morex)
    {
        modelo2Morex.rotation.y = scrollY * 0.5
    }*/
    // Update controls
    //controls.update()


    // Render
    renderer.render(scene, camera)

    // Call tick again on the next frame
    window.requestAnimationFrame(tick)
}

tick()